/// <reference path="./env.d.ts" />
// ============================================
// @gs/config/browser — Vite / navigateur uniquement (import.meta.env)
// Ne pas importer ce module depuis les serveurs bundlés en CJS (esbuild).
// ============================================
import { clientEnvSchema, } from './index.js';
// Adresses des applications du parc — SOURCE UNIQUE, definie dans ./index.ts et
// re-exportee ici pour que les SPA gardent le sous-chemin qu'elles importent
// deja (`@gs/config/browser`) au lieu d'ouvrir un second point d'entree.
export { GS_APP_URLS } from './index.js';
let _clientConfig = null;
// Reference STABLE — un litteral recree a chaque getConfig() rendait `scopes`
// instable cote React (AuthProvider), d'ou une boucle ssoSilent -> AADSTS50196.
const BROWSER_AUTH_SCOPES = ['User.Read', 'openid', 'profile', 'email'];
function formatZodIssues(err) {
    return err.issues.map((e) => `${e.path.join('.') || '(root)'}: ${e.message}`).join('; ');
}
/**
 * L adresse de l API quand le paquet ne la porte pas (lot feat-le-passage-du-soir, 2026-10-29,
 * E-20260929-le-paquet-de-la-copie-renvoie-vers-la-production). Le flux de deploiement ne fige plus
 * l adresse de la production dans le paquet : construit, le navigateur prend l origine de la page, et
 * le MEME paquet sert la copie puis la production apres la bascule. En developpement, rien ne change :
 * le defaut du schema (le serveur local). Une adresse passee a la construction gagne toujours.
 */
export function adresseDeLApi(brute, production, origine) {
    if (typeof brute === 'string' && brute.trim() !== '')
        return brute;
    return production && origine ? origine : brute;
}
/**
 * Valide les variables Vite (lazy, cache).
 * À utiliser uniquement depuis le frontend (Vite).
 */
export function getClientConfig() {
    if (_clientConfig)
        return _clientConfig;
    const raw = {
        VITE_AZURE_AD_CLIENT_ID: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
        VITE_AZURE_AD_TENANT_ID: import.meta.env.VITE_AZURE_AD_TENANT_ID,
        VITE_AZURE_AD_REDIRECT_URI: import.meta.env.VITE_AZURE_AD_REDIRECT_URI,
        VITE_API_URL: adresseDeLApi(import.meta.env.VITE_API_URL, import.meta.env.MODE === 'production', typeof window !== 'undefined' ? window.location.origin : undefined),
    };
    const result = clientEnvSchema.safeParse(raw);
    if (!result.success) {
        console.error(`[gs/config] Variables Vite invalides : ${formatZodIssues(result.error)}`);
        _clientConfig = {
            VITE_AZURE_AD_CLIENT_ID: '',
            VITE_AZURE_AD_TENANT_ID: '',
            VITE_AZURE_AD_REDIRECT_URI: undefined,
            VITE_API_URL: 'http://localhost:3001',
        };
        return _clientConfig;
    }
    _clientConfig = result.data;
    return _clientConfig;
}
/**
 * Configuration agrégée pour le navigateur (MSAL, API URL, etc.).
 * @deprecated Préférer les getters ciblés ; conservé pour @gs/auth.
 */
/** True si `VITE_USE_MOCK=true` — développement sans API réelle */
export const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true';
export function getConfig() {
    const c = getClientConfig();
    const mode = import.meta.env.MODE;
    const nodeEnv = mode === 'production' ? 'production' : mode === 'test' ? 'test' : 'development';
    return {
        sql: {},
        auth: {
            clientId: c.VITE_AZURE_AD_CLIENT_ID,
            tenantId: c.VITE_AZURE_AD_TENANT_ID,
            redirectUri: c.VITE_AZURE_AD_REDIRECT_URI && c.VITE_AZURE_AD_REDIRECT_URI !== ''
                ? c.VITE_AZURE_AD_REDIRECT_URI
                : window.location.origin,
            scopes: BROWSER_AUTH_SCOPES,
        },
        storage: {},
        apiUrl: c.VITE_API_URL,
        nodeEnv,
    };
}
//# sourceMappingURL=browser.js.map